import { Values } from '@lib/interfaces/form';
import _get from 'lodash/get';
import mergeAndUnlinkMultiSelectValues, {
  Items,
} from '@lib/utils/mergeAndUnlinkMultiSelectValues';
import { DocumentationUpdateInputObject } from 'graphql-common';
import AssetDocumentFieldNames from '@lib/enums/fieldNames/assetDocumentFieldNames';
import { SelectOption } from '@lib/components/Select/types';
import { prepareAttachedField } from '@lib/utils/prepareAttachedField';

export default function getPreparedUpdateFromValues(
  values: Values,
  oldValues: Values,
) {
  const attachmentAttached = prepareAttachedField(
    _get(values, AssetDocumentFieldNames.Document),
    { pickFileFields: true, includeFilename: false },
  );
  const tags = _get(values, AssetDocumentFieldNames.Tags, []) as SelectOption[];
  const newTags = tags.map(({ value }: SelectOption) => ({
    id: `${value}`,
  }));
  return {
    attachmentAttached,
    documentationTags: mergeAndUnlinkMultiSelectValues(
      _get(oldValues, 'tags', []) as Items,
      newTags,
    ),
    name: _get(values, AssetDocumentFieldNames.Name),
  } as DocumentationUpdateInputObject;
}
